import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import MDTypography from "shared/ui/Typography/MDTypography";

function DemoModeDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="demo-mode-dialog-title"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 3 }}
    >
      <DialogTitle id="demo-mode-dialog-title" sx={{ textAlign: "center" }}>
        Modo demo
      </DialogTitle>

      <DialogContent>
        <MDTypography variant="body2" textAlign="center">
          Esta acción está desactivada para proteger los datos compartidos de la demo.
        </MDTypography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={onClose} variant="contained" color="primary">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DemoModeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DemoModeDialog;
